var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mu-appbar',{staticClass:"tc pre top-bar"},[_c('img',{staticClass:"logo pab centre1",attrs:{"src":require("../assets/images/logo.png"),"alt":"logo"}}),_vm._v(" "),_c('mu-flat-button',{attrs:{"slot":"right","label":"发布"},nativeOn:{"click":function($event){_vm.releaseTopic($event)}},slot:"right"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-6d963ab6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/appBar.vue
// module id = null
// module chunks = 